import {Observable, of} from "rxjs";
import {ErrorResponse} from "../../tools/error-response";
import {concatMap, finalize} from "rxjs/operators";
import {ExtractedDeviceSerial} from "./upload.service";
import {nurseAndDeviceSerialsMatch} from "./nurse-and-device-serials-match";

export class UploadActionHelper {
  constructor(private readonly fields: {
    measurementId: number | undefined;
    nurseDeviceSerial: string | undefined;
    uploadInitiated: () => Observable<void>;
    uploadNoninitiated: () => Observable<void>;
    extractAndSaveDeviceSerial: () => Observable<{ deviceSerial: string }>;
  }) {
  }

  private uploadState: "SERIALS_DO_NOT_MATCH" | "INITIAL_CLICK" = "INITIAL_CLICK";

  onUploadClick(
    {
      onUploadSuccessful,
      onDeviceSerialsDoNotMatch,
      onError,
      onActionFinished
    }: {
      onUploadSuccessful: () => void;
      onDeviceSerialsDoNotMatch: (extractedDeviceSerial: ExtractedDeviceSerial) => void;
      onError: (errorResponse: ErrorResponse) => void;
      onActionFinished: () => void;
    }): void {

    const confirmUpload = this.uploadState === "SERIALS_DO_NOT_MATCH";

    const observable = confirmUpload
      ? this.createUploadObservable()
      : this.createExtractThenUploadObservable(onDeviceSerialsDoNotMatch);

    observable!
      .pipe(finalize(() => onActionFinished()))
      .subscribe({
        next: () => {
          if (this.uploadState === "INITIAL_CLICK" || confirmUpload) {
            onUploadSuccessful();
          }
        },
        error: onError
      });
  }

  private createExtractThenUploadObservable(onDeviceSerialsDoNotMatch: (extractedDeviceSerial: ExtractedDeviceSerial) => void) {
    return this.fields.extractAndSaveDeviceSerial()
      .pipe(
        concatMap(extractedDeviceSerial => {
            if (!nurseAndDeviceSerialsMatch(this.fields.nurseDeviceSerial, extractedDeviceSerial.deviceSerial)) {
              onDeviceSerialsDoNotMatch(extractedDeviceSerial);
              this.uploadState = "SERIALS_DO_NOT_MATCH";
              return of(void 0);
            } else {
              return this.createUploadObservable();
            }
          }
        ));
  }

  private createUploadObservable() {
    return this.fields.measurementId
      ? this.fields.uploadInitiated()
      : this.fields.uploadNoninitiated();
  }

}
